import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload, faFileExport } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import sendButtonImg from "../../assets/images/send-chat-button.png";
import {
    addRiskRegister,
    approveReview,
    rejectReview,
    reviewResponse,
    uploadImageInChat,
    exportReviewResponse
} from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import { useWebSocket } from '../WebSocket/useWebSocket';
import Loader from "../Shared/loader";

const ReviewResponse = () => {
    const { _id } = useParams();
    const { chatId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const id = useSelector((state) => state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const showDetails = useSelector((state) => state?.riskManagement?.reviewResponse?.data?.questionForm);
    const totalQuestion = useSelector((state) => state?.riskManagement?.reviewResponse?.data);
    const auth = useSelector((state) => state?.auth?.user?.accessLevel);

    // Add state for AI marked risk filter
    const [onlyAIMarkedRisk, setOnlyAIMarkedRisk] = useState(false);

    // State Management
    const [isModal, setModal] = useState("");
    const [isModalData, setModalData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [messageInput, setMessageInput] = useState('');
    const [registerFor, setRegisterFor] = useState("forever");
    const [riskLevel, setRiskLevel] = useState("low");
    const [questionId, setQuestionId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [riskNote, setRiskNote] = useState("");
    const [riskTitle, setRiskTitle] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileSent, setFileSent] = useState("");
    const [chatData, setChatData] = useState([]);
    const [assigneeOrganisationId, setAssigneeOrganisationId] = useState("");
    const {
        connectionStatus,
        messageAll,
        messageSend,
        sendMessage,
        getMessages
    } = useWebSocket({
        userId: id,
        orgId: id
    });
    const [isChatMinimized, setIsChatMinimized] = useState(false);
    const [showApproveConfirm, setShowApproveConfirm] = useState(false);
    const [showRejectConfirm, setShowRejectConfirm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (chatId) {
            const category = showDetails?.form?.find(cat =>
                cat?.categoryQuestions?.some(question => question?.id === chatId)
            );

            const questionData = category?.categoryQuestions?.find(question =>
                question.id === chatId
            );

            if (category && questionData) {
                getMessages({
                    organisationId: id,
                    questionCategoryId: category?.id,
                    questionFormId: _id,
                    questionId: questionData?.id
                });

                setCategoryId(category?.id);
                setQuestionId(questionData?.id);
                setChatData([category?.categoryName, questionData?.id, category?.id]);
            }
        }
    }, [chatId, showDetails, id, _id]);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('files', file);

        uploadImageInChat(formData)
            .then(response => {
                setFileSent(response);
                setSelectedFile(file);
            })
            .catch(error => {
                // console.error removed
            });
    };


    const sendMessages = () => {
        if (messageInput == "") {
            toastr.error("Please enter the message.");
            return
        }
        sendMessage({
            messageText: messageInput,
            questionFormId: _id,
            questionCategoryId: categoryId,
            questionId: questionId,
            toOrganisationId: assigneeOrganisationId,
            ...(fileSent?.data && {
                attachedFiles: fileSent?.data
            })
        });
        setMessageInput("");
        setFileSent("");
        setSelectedFile("");
        const chatContainer = document.querySelector('.chatBoxMain');
        if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    };


    const chatOpenBox = async (c, a, i, event) => {
        // Get the clicked question's container element
        const questionElement = event.target.closest('.question-container');
        const questionRect = questionElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        getMessages({
            organisationId: id,
            questionCategoryId: i,
            questionFormId: _id,
            questionId: a?.id
        });
        setCategoryId(i);
        setQuestionId(a?.id);
        setChatData([c, a, i]);
        setIsChatMinimized(false);

        // Increased the offset from 20px to 50px to move the chat panel higher up
        const chatTop = questionRect.top + scrollTop - 250;
        document.documentElement.style.setProperty('--chat-top-position', `${chatTop}px`);
    };


    useEffect(() => {  
        if(id && _id){
            reviewResponse(id, dispatch, _id, page, onlyAIMarkedRisk)
        }
    }, [id, _id, page, dispatch, onlyAIMarkedRisk]);

    useEffect(() => {
        setAssigneeOrganisationId(showDetails?.assigneeOrganisationId)
    }, [showDetails?.assigneeOrganisationId])

    useEffect(() => {
        setTotalItems(totalQuestion?.totalQuestions);
    }, [totalQuestion?.totalQuestions]);

    useEffect(() => {
        setIsLoading(true);
        if (_id) {
            if (showDetails?.form) {
                setModalData(showDetails.form);
                setIsLoading(false);
            }
        }
    }, [showDetails?.form, _id]);

    useEffect(() => {
        const chatContainer = document.querySelector('.chatBoxMain');
        if (chatContainer && messageAll?.length > 0) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    }, [messageAll]);

    // Action handlers
    const handleRouteChange = () => history.push('/tprm/assessment-campaign');
    const approveBtn = (_id) => approveReview(id, _id, [], handleRouteChange);
    const rejectBtn = () => rejectReview(id, _id, [], handleRouteChange);
    const openModal = () => setModal("Form Wizard modal risk");

    const closeModal = () => {
        setRiskLevel("low");
        setRiskNote("");
        setRiskTitle("");
        setQuestionId("");
        setModal("");
    }

    const saveRisk = () => {
        if (riskTitle == "") {
            toastr.error("Title is required")
            return
        }
        if (riskLevel == "") {
            toastr.error("Risk Level is required")
            return
        }
        if (riskNote == "") {
            toastr.error("Comment is required")
            return
        }
        let data = {
            categoryId,
            questionId,
            riskNote,
            riskLevel,
            title: riskTitle,
        }
        addRiskRegister(id, _id, data, dispatch, closeModal)
    }

    const confirmApprove = () => {
        approveBtn(showDetails?._id);
        setShowApproveConfirm(false);
    };

    const confirmReject = () => {
        rejectBtn();
        setShowRejectConfirm(false);
    };

    const getRiskLevelColor = (level) => {
        const colors = {
            low: '#28a745',
            medium: '#ffc107',
            high: '#fd7e14',
            critical: '#dc3545'
        };
        return colors[level] || '#2a2a2a';
    };

    useEffect(() => {
        document.documentElement.style.setProperty('--chat-top-position', '0px');
    }, []);

    const handleExport = async () => {
        try {
            await exportReviewResponse(id, _id);
            toastr.success("Success", "Response exported successfully");
        } catch (error) {
            toastr.error("Error", error);
        }
    };

    return (
        <div className="container-fluid risk-dashboard">
            {isLoading && <Loader />}
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/tprm/assessment-campaign" className="welcome-textSmall">Third Party Assessment Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active"
                                    aria-current="page"
                                    style={{ color: "white" }}
                                >
                                    Check Response
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="mb-4" style={{ backgroundColor: '#f3f3f3', borderRadius: '4px', padding: '15px' }}>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <span className="mr-2">📋</span>
                                    <div>
                                        <h6 className="mb-0">Total Questions</h6>
                                        <h5 className="mb-0">{totalItems}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <span className="mr-2">⏳</span>
                                    <div>
                                        <h6 className="mb-0">Time Remaining</h6>
                                        <h5 className="mb-0">
                                            {moment(showDetails?.dueDate).diff(moment(), 'days')} days
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <span className="mr-2">🤖</span>
                                    <div>
                                        <h6 className="mb-0">AI Marked Risks</h6>
                                        <div className="form-check form-switch mt-1">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="aiRiskToggle"
                                                checked={onlyAIMarkedRisk}
                                                onChange={(e) => setOnlyAIMarkedRisk(e.target.checked)}
                                                style={{ 
                                                    cursor: 'pointer',
                                                    backgroundColor: onlyAIMarkedRisk ? '#28a745' : '#6c757d',
                                                    borderColor: onlyAIMarkedRisk ? '#28a745' : '#6c757d'
                                                }}
                                            />
                                            <label 
                                                className="form-check-label" 
                                                htmlFor="aiRiskToggle"
                                                style={{ 
                                                    color: onlyAIMarkedRisk ? '#28a745' : '#6c757d',
                                                    fontWeight: onlyAIMarkedRisk ? 'bold' : 'normal'
                                                }}
                                            >
                                                {onlyAIMarkedRisk ? 'AI Risks Only' : 'Show All'}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center justify-content-end">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleExport();
                                        }}
                                        href="/add-report"
                                        className="btn btn-sm btn-primary mr-1 download-report"
                                    >
                                        Export Response
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ opacity: isLoading ? 0.6 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                        <div className="table-responsive table-risk mt-3">
                            <table className="table mb-0">
                                <thead>
                                    <tr>
                                        <th>Sender Name</th>
                                        <th>Vendor Name</th>
                                        <th>Due Date</th>
                                        <th>Questionnaire Forms</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{showDetails?.assigneeOrganisationName}</td>
                                        <td>{showDetails?.assignerOrganisationName}</td>
                                        <td>{moment(showDetails?.dueDate).format("DD-MM-YYYY")}</td>
                                        <td>{showDetails?.formTitle}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <div className="group-box p-0 border-none">
                                <div>
                                    <div className="d-flex">
                                        <div className={`card ${chatData.length > 0 && !isChatMinimized ? 'w-70' : 'w-100'}`}>
                                            {isModalData?.map((category, catIndex) => (
                                                <Accordion key={catIndex} className="mb-0" defaultExpanded>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`panel${catIndex}-content`}
                                                        id={`panel${catIndex}-header`}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center w-100 mr-3">
                                                            <div>
                                                                <strong>{category?.categoryName}</strong>
                                                                <span className="boxButton ml-2" title="Number of questions in this category">
                                                                    {category?.categoryQuestions?.length} Questions
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div className="boxAccordian">
                                                            {category?.categoryQuestions?.map((question, qIndex) => (
                                                                <div key={qIndex} className="question-container">
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <p>
                                                                            {(page - 1) * 10 + 1 + qIndex}. {question?.question_text}
                                                                        </p>
                                                                        <div className="d-flex gap-2">
                                                                            <button
                                                                                onClick={(event) => chatOpenBox(category?.categoryName, question, category?.id, event)}
                                                                                className="btn btn-link p-0"
                                                                                style={{
                                                                                    color: '#6563ff',
                                                                                    textDecoration: 'none',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '5px'
                                                                                }}
                                                                            >
                                                                                <span>💬</span>
                                                                                <small>Follow-up</small>
                                                                            </button>
                                                                            <button
                                                                                onClick={() => {
                                                                                    setQuestionId(question?.id);
                                                                                    setCategoryId(category?.id);
                                                                                    setRiskTitle(question?.riskAnalysis?.title || '');
                                                                                    setRiskNote(question?.riskAnalysis?.comments || '');
                                                                                    setRiskLevel(question?.riskAnalysis?.riskLevel || 'low');
                                                                                    openModal();
                                                                                }}
                                                                                className="btn btn-link p-0"
                                                                                style={{
                                                                                    color: '#dc3545',
                                                                                    textDecoration: 'none',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '5px'
                                                                                }}
                                                                            >
                                                                                <span>⚠️</span>
                                                                                <small>Raise Risk</small>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    {/* Add Risk Analysis Information Display */}
                                                                    {question?.riskAnalysis?.hasRisk == true && question?.riskAnalysis && (question?.riskAnalysis?.title || question?.riskAnalysis?.comments) && (
                                                                        <div
                                                                            className="risk-analysis-container mt-2 mb-3"
                                                                            style={{
                                                                                backgroundColor: '#fff8f8',
                                                                                border: '1px solid #ffe0e0',
                                                                                borderRadius: '6px',
                                                                                padding: '10px 15px',
                                                                                marginTop: '8px'
                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center mb-1">
                                                                                <span style={{ fontSize: '16px', marginRight: '8px' }}>⚠️</span>
                                                                                <h6 style={{ margin: 0, color: '#d63031', fontWeight: 'bold' }}>
                                                                                    Risk Analysis: {question?.riskAnalysis?.title || 'Untitled Risk'}
                                                                                </h6>
                                                                            </div>
                                                                            {question?.riskAnalysis?.comments && (
                                                                                <p style={{ fontSize: '14px', color: '#4d4d4d', margin: '5px 0 0 28px' }}>
                                                                                    {question?.riskAnalysis?.comments}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {question?.evidence && question?.response?.evidences?.map((r, index) => {
                                                                        const filename = r?.fileKey?.split('/')?.pop()?.split('-')?.slice(-1)[0] || 'Download File';
                                                                        return (
                                                                            <div key={index} className="file-download-section" style={{ maxWidth: 'fit-content' }}>
                                                                                <a
                                                                                    href={r?.signedUrl}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    download={filename}
                                                                                    className="download-link"
                                                                                >
                                                                                    📎 {filename}
                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                    <div className="mb-4">
                                                                        {question?.type === "text" ? (
                                                                            <textarea
                                                                                className="form-control border-0 inputUpdateLastest"
                                                                                rows="4"
                                                                                placeholder="No response provided"
                                                                                disabled
                                                                                value={question?.response?.value || ''}
                                                                            ></textarea>
                                                                        ) : (
                                                                            <div className="options-container">
                                                                                {question?.options?.map((option, optIndex) => {
                                                                                    const isSelected = Array.isArray(question?.response?.value)
                                                                                        ? question?.response?.value?.includes(option)
                                                                                        : question?.response?.value === option;

                                                                                    return (
                                                                                        <div
                                                                                            key={optIndex}
                                                                                            className={`form-control w-50 mt-2 mb-3 border-0 inputUpdateLastest cursor
                                                                                                ${isSelected ? 'selectedInput' : ''}`}
                                                                                            style={{
                                                                                                backgroundColor: isSelected ? '#08283f' : '#fff',
                                                                                                color: isSelected ? '#fff !important' : '#495057',
                                                                                                border: isSelected ? '2px solid #08283f' : '1px solid #e0e0e0',
                                                                                                fontWeight: isSelected ? 'bold' : 'normal',
                                                                                                padding: '8px 12px',
                                                                                                borderRadius: '8px'
                                                                                            }}
                                                                                        >
                                                                                            {`${option} ${isSelected ? '(Selected)' : ''}`}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )}
                                                                        {question?.showComment && (
                                                                            <div className="mt-3">
                                                                                <label className="text-muted mb-2">Additional Comments:</label>
                                                                                <textarea
                                                                                    className="form-control form-control-review border-0 inputUpdateLastest"
                                                                                    rows="4"
                                                                                    value={question?.response?.comment || ''}
                                                                                    placeholder="No comments provided"
                                                                                    disabled
                                                                                ></textarea>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}
                                            <div className="dataTables_paginate ml-2 d-flex justify-content-end align-items-center">
                                                {totalItems > 0 && (
                                                    <Pagination
                                                        className="pagination-bar"
                                                        currentPage={page}
                                                        totalCount={totalItems}
                                                        pageSize={10}
                                                        onPageChange={(page) => setPage(page)}
                                                    />
                                                )}
                                                {page === Math.ceil(totalItems / 10) && <>
                                                    <button
                                                        onClick={() => rejectBtn(showDetails?._id)}
                                                        className="btn btn-danger mr-2"
                                                    >
                                                        Reject
                                                    </button>
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={() => approveBtn(showDetails?._id)}
                                                    >
                                                        Approve
                                                    </button>
                                                </>}
                                            </div>
                                        </div>

                                        {chatData.length > 0 && (
                                            <div className={`chat-panel ${isChatMinimized ? 'minimized' : ''}`}
                                                style={{
                                                    position: 'fixed',
                                                    right: '20px',
                                                    top: 'var(--chat-top-position)',
                                                    width: isChatMinimized ? '250px' : '30%',
                                                    maxWidth: '450px',
                                                    minWidth: '250px',
                                                    backgroundColor: '#ffffff',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                    transition: 'all 0.3s ease',
                                                    zIndex: 1000
                                                }}>
                                                <div className="chat-header"
                                                    style={{
                                                        padding: '10px 15px',
                                                        borderBottom: '1px solid #e0e0e0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#f8f9fa'
                                                    }}
                                                    onClick={() => setIsChatMinimized(!isChatMinimized)}>
                                                    <div className="d-flex align-items-center">
                                                        <span className="mr-2" style={{ color: '#6563ff' }}>💬</span>
                                                        <span style={{ color: '#495057' }}>Follow-up: {chatData[1]?.question_text}</span>
                                                    </div>
                                                    <div>
                                                        {isChatMinimized ?
                                                            <span style={{ color: '#6563ff' }}>▲</span> :
                                                            <span style={{ color: '#6563ff' }}>▼</span>
                                                        }
                                                    </div>
                                                </div>

                                                {!isChatMinimized && (
                                                    <>
                                                        <div className="chat-body"
                                                            style={{
                                                                height: '400px',
                                                                overflowY: 'auto',
                                                                padding: '15px',
                                                                backgroundColor: '#ffffff'
                                                            }}>
                                                            <div className="question-context"
                                                                style={{
                                                                    backgroundColor: '#f8f9fa',
                                                                    padding: '15px',
                                                                    borderRadius: '8px',
                                                                    marginBottom: '15px',
                                                                    border: '1px solid #e0e0e0'
                                                                }}>
                                                                <small style={{ color: '#6c757d' }}>Original Question:</small>
                                                                <p className="mb-1" style={{ color: '#495057' }}>{chatData[1]?.question_text}</p>
                                                                <small style={{ color: '#6c757d' }}>Answer:</small>
                                                                <p style={{ color: '#495057' }}>{chatData?.type == "text" ?
                                                                    chatData[1]?.response?.value :
                                                                    Array.isArray(chatData[1]?.response?.value) ?
                                                                        chatData[1]?.response?.value.join(', ') :
                                                                        chatData[1]?.response?.value}
                                                                </p>
                                                            </div>

                                                            {messageAll?.map((r) => (
                                                                <div
                                                                    className={r?.type == "sent" ? "boxCChat" : "boxBChat"}
                                                                    key={r?.id || r?.createdAt}
                                                                    style={{
                                                                        marginBottom: '15px',
                                                                        padding: '10px 15px',
                                                                        borderRadius: '8px',
                                                                        backgroundColor: r?.type == "sent" ? '#f0f2ff' : '#f8f9fa',
                                                                        border: '1px solid #e0e0e0'
                                                                    }}
                                                                >
                                                                    <p style={{ color: '#495057', marginBottom: '5px' }}>
                                                                        {r?.messageText}
                                                                    </p>
                                                                    {r?.attachedFiles && (
                                                                        <>
                                                                            {r?.attachedFiles[0]?.fileType?.startsWith('image/') ? (
                                                                                <img
                                                                                    src={r?.attachedFiles[0]?.signedUrl}
                                                                                    className="img-fluid imgChatSend"
                                                                                    alt="chat attachment"
                                                                                    style={{ maxWidth: '200px', borderRadius: '4px' }}
                                                                                />
                                                                            ) : (
                                                                                <div className="file-download-section">
                                                                                    <a
                                                                                        href={r?.attachedFiles[0]?.signedUrl}
                                                                                        target="_blank"
                                                                                        download={r?.attachedFiles[0]?.fileName}
                                                                                        className="download-link"
                                                                                        style={{ color: '#6563ff', textDecoration: 'none' }}
                                                                                    >
                                                                                        📎 {r?.attachedFiles[0]?.fileName}
                                                                                    </a>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    <p className="recieveTime" style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                                                                        {moment(r?.createdAt).format("DD-MM-YYYY || HH:mm")}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className="chat-input"
                                                            style={{
                                                                borderTop: '1px solid #e0e0e0',
                                                                padding: '10px',
                                                                backgroundColor: '#ffffff'
                                                            }}>
                                                            <div className="d-flex align-items-center w-100">
                                                                <div className="ReplyBox w-100">
                                                                    <div className="input-group" style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#ffffff',
                                                                        borderRadius: '8px',
                                                                        padding: '5px 15px',
                                                                        border: '1px solid #e0e0e0',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                                    }}>
                                                                        <input
                                                                            placeholder="Type your message..."
                                                                            value={messageInput}
                                                                            onKeyDown={(e) => e.key === 'Enter' && sendMessages()}
                                                                            onChange={(e) => setMessageInput(e.target.value)}
                                                                            className="form-control border-0"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                border: 'none',
                                                                                boxShadow: 'none',
                                                                                color: '#495057',
                                                                                flex: '1',
                                                                                padding: '8px 12px'
                                                                            }}
                                                                        />
                                                                        <div className="input-group-append" style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '10px',
                                                                            marginLeft: '10px'
                                                                        }}>
                                                                            <FontAwesomeIcon
                                                                                icon={faFileUpload}
                                                                                onClick={() => fileInputRef.current?.click()}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: '#6563ff',
                                                                                    fontSize: '16px',
                                                                                    transition: 'color 0.2s'
                                                                                }}
                                                                                className="attachment-icon"
                                                                            />
                                                                            <img
                                                                                src={sendButtonImg}
                                                                                onClick={sendMessages}
                                                                                alt="Send"
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    width: '20px',
                                                                                    height: '20px',
                                                                                    transition: 'opacity 0.2s'
                                                                                }}
                                                                                className="send-icon"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {selectedFile && (
                                                                        <div className="selected-file mt-2" style={{
                                                                            backgroundColor: '#f8f9fa',
                                                                            padding: '5px 12px',
                                                                            borderRadius: '15px',
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            border: '1px solid #e0e0e0'
                                                                        }}>
                                                                            <span style={{ color: '#495057' }}>
                                                                                📎 {selectedFile.name}
                                                                            </span>
                                                                            <button
                                                                                onClick={() => setSelectedFile(null)}
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    color: '#dc3545',
                                                                                    cursor: 'pointer',
                                                                                    padding: '0 5px'
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                    <input
                                                                        type="file"
                                                                        onChange={(e) => handleFileChange(e)}
                                                                        ref={fileInputRef}
                                                                        style={{ display: 'none' }}
                                                                        accept="image/*, .pdf, .doc, .docx"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal risk" ? "d-block show" : ""}`}>
                <div className="modal-dialog modal-lg" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Raise a risk
                            </h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal("")}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page" style={{ height: 'auto' }}>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="card mb-2">
                                    <div className="row clearfix">
                                        <div className="form-group col-lg-12 col-md-12">
                                            <label>
                                                Risk Title
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={riskTitle}
                                                onChange={(e) => setRiskTitle(e.target.value)}
                                                placeholder="Enter risk title"
                                            />
                                        </div>
                                        <div className="form-group col-md-12">
                                            <label>Risk Type
                                            </label>
                                            <select
                                                className="custom-select custom-select-sm form-control form-control-sm"
                                                value={riskLevel}
                                                onChange={(e) => setRiskLevel(e.target.value)}
                                            >
                                                <option value="low">Low</option>
                                                <option value="medium">Medium</option>
                                                <option value="high">High</option>
                                                <option value="critical">Critical</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-12">
                                            <label>
                                                Comment
                                            </label>
                                            <textarea
                                                rows="3"
                                                placeholder="Enter risk comment"
                                                className="form-control"
                                                value={riskNote}
                                                onChange={(e) => setRiskNote(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-12" style={{ display: 'block', width: '100%', textAlign: 'end' }}>
                                            <button className="send-button mr-2"
                                                onClick={() => {
                                                    saveRisk()
                                                }}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewResponse;



